import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton, IonIcon } from '@ionic/react';
import './CardPassItem.css';
import { currencyFormat } from '../../utils/currency';
import { datesFromString, datesLocaleFormatTimeDate } from '../../utils/dates';

type CardPassItemProps = {
  activateUntil?: string;
  title: string;
  price?: number;
  isActive?: boolean;
  statusColor?: string;
  info?: string;
  validityDescription?: string;
  pay?: () => void;
};

export default function CardPassItem({
  activateUntil,
  title,
  price,
  isActive,
  statusColor,
  validityDescription,
  info,
  pay,
}: CardPassItemProps) {
  const [t] = useTranslation('global');

  const statusMessage = useMemo(
    () =>
      isActive
        ? t('cardpasses.statusactive')!
        : t('cardpasses.statusinactive')!,
    [isActive, t],
  );

  const infoMessage = useMemo(
    () =>
      typeof isActive === 'boolean' &&
      (isActive
        ? t('cardpasses.activeInfo', {
            date: datesLocaleFormatTimeDate(
              datesFromString(validityDescription!),
            ),
          })!
        : t('cardpasses.inactiveInfo', {
            date: datesLocaleFormatTimeDate(datesFromString(activateUntil!)),
          })!),
    [isActive, activateUntil, t],
  );

  const hasPrice = typeof price === 'number' || typeof price === 'string';

  return (
    <div className="farecard-pass-item">
      <div className="farecard-pass-item-top">
        <IonIcon slot="start" src={'assets/icon/pass-logo.svg'}></IonIcon>
        <div className="farecard-pass-item-details">
          <div>{title}</div>
          {statusColor && (
            <div className="farecard-pass-item-status">
              {t('cardpasses.status')} &middot;{' '}
              <span className={statusColor!}>{statusMessage}</span>
            </div>
          )}
          <div className="farecard-pass-item-purchase pt-1 pb-1">
            {hasPrice && (
              <div className="farecard-pass-item-price">
                {currencyFormat(price / 100)}
              </div>
            )}
            {pay && (
              <div className="farecard-pass-item-pay">
                <IonButton onClick={() => pay()}>
                  <b>{t('cardpasses.buy')}</b>
                </IonButton>
              </div>
            )}
          </div>
        </div>
      </div>
      {(infoMessage || info) && (
        <div className="farecard-pass-item-info">{infoMessage || info}</div>
      )}
    </div>
  );
}
